// extracted by mini-css-extract-plugin
export var progressBar = "_n6-0";
export var progressBarInner = "_n6-1";